import dayjs from 'dayjs'
import LowPriorityIcon from '@/assets/crm/LowPriority.svg'
import NormalPriorityIcon from '@/assets/crm/NormalPriority.svg'
import HighPriorityIcon from '@/assets/crm/HighPriority.svg'
import TopPriorityIcon from '@/assets/crm/TopPriority.svg'
import type { CrmSection } from '@/services/crmService'

/** Section colours shared by the section header, the status badge and its picker. */
export const CRM_SECTION_COLORS: Record<CrmSection, string> = {
  open: '#8577E6',
  in_progress: '#F79268',
  done: '#46BE8B',
}

export const CRM_SECTION_TITLES: Record<CrmSection, string> = {
  open: 'פתוח',
  in_progress: 'בתהליך',
  done: 'בוצע',
}

export const CRM_SECTIONS: CrmSection[] = ['open', 'in_progress', 'done']

export const CRM_OVERDUE_COLOR = '#FE595A'

/** Priority is the alert severity scale; the icon is the nearest of the four UI levels. */
const PRIORITY_ICONS: { value: number; icon: string }[] = [
  { value: -10, icon: LowPriorityIcon },
  { value: 0, icon: NormalPriorityIcon },
  { value: 10, icon: HighPriorityIcon },
  { value: 20, icon: TopPriorityIcon },
]

export const getPriorityIcon = (
  priority: number | null | undefined
): string | null => {
  if (priority == null || Number.isNaN(Number(priority))) return null
  const p = Number(priority)
  return PRIORITY_ICONS.reduce((best, cur) =>
    Math.abs(cur.value - p) < Math.abs(best.value - p) ? cur : best
  ).icon
}

/** he-IL display date: DD/MM/YYYY, or '-' when empty. */
export const formatCrmDate = (iso: string | null | undefined): string => {
  if (!iso) return '-'
  const d = dayjs(iso)
  return d.isValid() ? d.format('DD/MM/YYYY') : '-'
}

export const formatCrmDateTime = (iso: string | null | undefined): string => {
  if (!iso) return '-'
  const d = dayjs(iso)
  return d.isValid() ? d.format('DD/MM/YYYY HH:mm') : '-'
}

/** Overdue per the server flag when present, otherwise due date before today. */
export const isCrmOverdue = (
  dueAt: string | null | undefined,
  overdue?: boolean | null
): boolean => {
  if (overdue != null) return overdue
  if (!dueAt) return false
  return dayjs(dueAt).isBefore(dayjs(), 'day')
}
